import {emptyEffects, Template} from "app/types/model-types"
import {projectId} from "app/helpers/api"
import { defaultTemplateSize } from "shape-edit/forms/helpers"
import _find from "lodash/find"

export default function() : Template {
    return {
        id: null,
        priority: null,
        size: defaultTemplateSize,
        size_id: null,
        is_keep_size: null,
        effect_id: null,
        gradient_id: null,
        gradient: null,
        gradients: null,
        effects: {...emptyEffects, project_id: projectId},
        name: "",
        type: null,
        background: "#ffffff",
        background_colors: null,
        background_gradient_ids: null,
        background_type: null,
        alpha: null,
        queries: [],
        shapes: [],
        groups: [],
        active: 1,
        active_from: null,
        active_to: null,
        project_id: projectId,
        enlarge: 1,
        is_collage: 0,
        collage_layout_id: null,
        crop: 0,
        flip: 0,
        flop: 0,
        rotation: 0,
        created_at: null,
        updated_at: null,
        translate_y: 0,
        translate_x: 0,
        enlarge_by: "fit",
        overscan: 0,
        outpaint_over: 0,
        max_image_width: 0,
        max_image_height: 0,
        collage_all_available_only: null,
        is_anim_gif: null,
        is_autocrop: null,
        frames_delay: null,
        loops_delay: null,
        watermark_group_id: null,
        inpainting_group_id: null,
        min_detection_accuracy: null,
        has_reflection: null,
        reflection_angle: null,
        reflection_offset: null,
        reflection_opacity: null,
        shadow_color: null,
        shadow_opacity: null,
        shadow_sigma: null,
        shadow_xoffset: null,
        shadow_yoffset: null,
        random_product_id: null
    }
}
